import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("hello-bar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_searchbar)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.onRefresh
          }, null, 8, ["onRefresh"]),
          _createVNode(_component_ag_text, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}